var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderimgx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 208,
    viewBox: "0 0 672 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_4553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.325 134.777L242.635 288.353L501.288 288.353L432.006 168.264L406.602 221.38L311.917 221.38L311.917 137.087C311.917 64.3863 252.981 5.45093 180.281 5.45093L150.259 5.45093C72.4564 5.45093 9.38525 68.5222 9.38525 146.324L9.38525 167.109C9.38525 244.911 72.4565 307.983 150.259 307.983H227.624L227.624 204.06L190.133 224.247C185.134 226.939 179.752 228.845 174.174 229.901C134.169 237.469 97.1425 206.791 97.1425 166.076V133.6C97.1425 104.354 119.782 80.0999 148.958 78.0877L168.203 76.7605C203.701 74.3123 235.111 99.5791 240.325 134.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.575,
    cy: 150.947,
    rx: 53.1162,
    ry: 54.2709,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_194_4553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.868 118.165L349.868 207.077H383.354L454.946 83.5238L578.499 292.525H661.637L498.825 8.46826L414.531 8.46826L349.868 118.165Z",
    fill: "#1C1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.721 137.795L261.031 291.37L519.684 291.37L450.402 171.281L424.998 224.397L330.313 224.397L330.313 140.104C330.313 67.4036 271.377 8.46826 198.677 8.46826L168.655 8.46826C90.8525 8.46826 27.7812 71.5395 27.7812 149.342L27.7812 170.126C27.7812 247.929 90.8525 311 168.655 311H246.02L246.02 207.077L208.529 227.264C203.53 229.956 198.148 231.863 192.57 232.918C152.565 240.486 115.539 209.808 115.539 169.094V136.617C115.539 107.372 138.178 83.1172 167.354 81.105L186.599 79.7778C222.097 77.3297 253.507 102.596 258.721 137.795Z",
    fill: "#1C1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_4553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 308,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_194_4553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 308,
    fill: "white",
    transform: "translate(336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderimgx);
export default __webpack_public_path__ + "static/media/loaderimgx.3d4f0ea6b4a8aa1e806b646322ee69be.svg";
export { ForwardRef as ReactComponent };